import styled from 'styled-components';

const ImageInfoDiv = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	overflow: hidden;
`;

const ImageNameDiv = styled.div`
	display: flex;
	flex-direction: row;
	gap: 6px;
	justify-content: flex-start;
	align-items: center;
	overflow: hidden;

	label{
		font-size: 0.938rem;
		font-weight: 500;
		color: var(--labelValueColor);
	}
	span{
		color: var(--labelValueColor);
		font-size: 0.938rem;
		font-weight: 400;
		display: inline-block;
		white-space: nowrap;
  	overflow: hidden;
  	text-overflow: ellipsis;
		max-width: fit-content;   
	}	
`;

const ImageActionDiv = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
	align-items: center;

	span{
		line-height: 1;
		cursor: pointer;
	}
`;

const ImageinfoWrap = styled.div`
	display: flex;
	padding: .75rem 1rem;
`;
const ImageEditorDiv = styled.div`
	display: flex;
	flex-direction: column;
	padding: .875rem;
	width: 100%;
	background: var(--surfaceColor);
	border: 1px solid var(--borderColor);
	border-radius: 4px;

`;

const ImageEditornputField = styled.div`
	// margin-top: 20px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

const CustomImageHeading = styled.div`
		border-bottom: 1px solid var(--borderColor);
    background: var(--surfaceColor);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.125rem 1rem .625rem;
		gap: 10px;
`;
const Heading = styled.h3`
	font-size: 17px;
	font-weight: 400;
	margin:0;
	color:#1F1F1F;
`;

const PanelWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 320px;
  background: var(--surfaceLightColor);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  min-height: 36px;
`;

const Title = styled.h2`
  color: var(--labelValueColor);
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0;
`;

const CloseButton = styled.button`
  font-size: 1.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
`;

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export {
	ImageNameDiv,
	ImageInfoDiv,
	ImageActionDiv,
	ImageEditorDiv,
	ImageEditornputField,
	CustomImageHeading,
	Heading,
	PanelWrapper,
	Header,
	Content,
	CloseButton,
	Title,
	ImageinfoWrap
};